import React, {useEffect, useState} from "react"
import {Form} from "react-bootstrap"
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import DescriptionField from "../../../../components/common/description-field/DescriptionField";
import ThemeButton from "../../../../components/common/theme-button/ThemeButton";
import {checkEmptySpaces, maxLength, Required} from "../../../../utils/patterns";
import "./add-gratitude.scss"
import {GratitudeService} from "../../../../services/gratitude-api.service";
import {QuestionService} from "../../../../services/questions-api.service";
import {CloseRoundedCheck, RoundedCheck} from "../../../../../assets/icons/defaultIcons";
import {notification} from "antd";
import EditGratitudeSkeleton from "../../../skeletons/gratitude/EditGratitudeSkeleton";

export default function EditGratitude({close, getListing, setGetListing, id}) {
    const[loader,setLoader] = useState(true);
    const[question,setQuestion] = useState(false);
    const [singleGratitudeData, setSingleGratitudeData] = useState(false)

    async function GetSingleGratitudeData(id) {
        setLoader(true)
        const response = await GratitudeService.getSingleGratitude(id);

        if(response?.data?.data?.status){
            setSingleGratitudeData(response.data?.data?.data?.result)

            const payload = {
                des: response?.data?.data?.data?.result.content[0].text
            };
            reset(payload);
            setLoader(false)
        }
    }

    useEffect(()=>{
        GetSingleGratitudeData(id)

    },[id])

    const {
        handleSubmit,
        reset,
        setValue,
        formState: {errors, isValid},
        control,
        clearErrors
    } = useForm({
        mode: 'onChange',
    })
    const navigate = useNavigate()

    const onSubmit = async (data) => {

        setLoader(true)

        if(data){
            let dummyQuestion = question;
            let payload = {
                questionId: question[0]._id,
                content: [
                    {
                        label: dummyQuestion.shift().multiQuestions.shift(),
                        text: data.des
                    }
                ]
            }
            const response = await GratitudeService.editGratitude(id,payload)

            if (response?.data?.data?.status){
                notification.success({
                    message: "Success",
                    description: "Gratitude updated Successfully",
                    placement: "topRight",
                    icon: <RoundedCheck/>,
                    duration: 2,
                });
                setGetListing(!getListing)
                setLoader(false)
            }
            else{
                notification.error({
                    message: "Failed",
                    description: "Login failed. Please check your credentials !",
                    placement: "topRight",
                    icon: <CloseRoundedCheck/>,
                    duration: 2,
                });
            }

        }

    }

    const questionPayload = {
        category: 'gratitude',
    }

    async function GetQuestion(payload) {
        const response = await QuestionService.getQuestion(payload);

        if(response?.data?.status) {
            setQuestion(response?.data?.data?.data)
        }
    }



    useEffect(()=>{
        GetQuestion(questionPayload)
    },[])

    useEffect(()=>{

    },[singleGratitudeData])

    if(loader){
        return <EditGratitudeSkeleton/>
    }

    return(
        <div className={'add-gratitude'}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className={'dfields'}>
                    <Controller
                        name="des"
                        defaultValue={''}
                        control={control}
                        rules={{required:Required, maxLength: maxLength(2000) , validate:checkEmptySpaces}}
                        render={({field: {name, ...field}}) => (
                            <DescriptionField
                                placeholder={'Write your text here'}
                                type={'text'}
                                field={field}
                                errors={errors.des}
                                autoSize={{ minRows: 12, maxRows: 12 }}
                                defaultValue={''}
                            />
                        )}
                    />
                </div>
                <div className={'mt-30'}>
                    <ThemeButton
                        text={'Submit'}
                        type={'submit'}
                        className={'btn-light-lg'}
                        loader={loader}
                    />
                </div>
            </Form>
        </div>
    )
}